export default "/images/vendor/flag-icon-css/flags/1x1/lt.svg?2ea82cfcd24756f9d718925a52c8efa7";